import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, ShieldCheck } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.me/50689925929?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20certificaci%C3%B3n%20de%20GAS%20LP%20para%20mi%20establecimiento';
export function FinalCTA() {
  return <section className="py-20 bg-[#1e3a5f] relative overflow-hidden" data-id="element-28">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2" data-id="element-29"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#f59e0b] rounded-full mix-blend-multiply filter blur-3xl opacity-10 translate-x-1/2 translate-y-1/2" data-id="element-30"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-32">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-33">
            No esperes a que te clausuren
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto" data-id="element-34">
            Cada día sin certificación es un riesgo para tu negocio. Asegura tu
            operación hoy mismo con la solución más rápida del mercado.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10" data-id="element-35">
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-5 bg-[#f59e0b] hover:bg-[#d97706] text-white font-bold rounded-lg shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 text-xl flex items-center justify-center gap-2" data-id="element-36">
              Certificar Mi Negocio Ahora
              <ArrowRight className="w-6 h-6" data-id="element-37" />
            </a>
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-5 bg-transparent border-2 border-white/20 hover:bg-white/10 text-white font-semibold rounded-lg transition-all flex items-center justify-center" data-id="element-38">
              WhatsApp: +506 8992-5929
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-blue-200" data-id="element-39">
            <div className="flex items-center gap-2" data-id="element-40">
              <Check className="w-4 h-4 text-[#f59e0b]" data-id="element-41" />
              <span data-id="element-42">Garantía de satisfacción</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-43">
              <ShieldCheck className="w-4 h-4 text-[#f59e0b]" data-id="element-44" />
              <span data-id="element-45">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-46">
              <Check className="w-4 h-4 text-[#f59e0b]" data-id="element-47" />
              <span data-id="element-48">Soporte incluido</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}